import React, { FC } from 'react';
import { Row } from 'reactstrap';
import { InfoCard, PageHeader, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, useFetcher } from '../../utils';

export const DealerDashboard: FC = () => {
  const { ts } = useTranslation();
  const request = useFetcher(async () => {
    return await api.getDealerStats();
  });

  if (!request.success) {
    return <Fetcher result={request} />;
  }

  const { data } = request;

  return (
    <UserStateComponent>
      <PageHeader>{ts('common.dashboard')}</PageHeader>
      <Row className="justify-content-center" id="dashboard">
        <InfoCard
          className="mb-10"
          heading="total_dealers"
          icon="people"
          id="totalDealers"
          largeText
          status="info"
          text={data.totalDealers}
        />
        <InfoCard
          className="mb-10"
          heading="approved_dealers"
          icon="people"
          id="totalApprovedDealers"
          largeText
          status="info"
          text={data.approvedDealers}
        />
        <InfoCard
          className="mb-10"
          heading="paid_dealers"
          icon="people"
          id="totalPaidDealers"
          largeText
          status="info"
          text={data.paidDealers}
        />
        <InfoCard
          className="mb-10"
          heading="approved_wo_reg"
          icon="people"
          id="totalConfirmedNoReg"
          largeText
          status="info"
          text={data.confirmedWithoutReg.length}
        />
        <InfoCard
          className="mb-10"
          heading="without_application"
          icon="people"
          id="noApplication"
          largeText
          status="info"
          text={data.withoutApplication.length}
        />
      </Row>
    </UserStateComponent>
  );
};
